import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSocureLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 160 50",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 33.33L16.68 50L33.35 33.33L16.68 16.67L0 33.33Z",
			fill: "#FF8200"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.68 0L0 16.67L16.68 33.33L33.35 16.67L16.68 0Z",
			fill: "#FF6900"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.67 33.32H33.35L25.0 25.0L16.67 33.32Z",
			fill: "#1C1C4C"
		}),
		/* @__PURE__ */ _jsx("text", {
			x: 45,
			y: 25,
			dominantBaseline: "central",
			fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
			fontWeight: 900,
			fontSize: 32,
			letterSpacing: "-0.02em",
			fill: "currentColor",
			children: "Socure"
		})
	]
});
export default SvgSocureLogo;
